import React, {Component} from 'react';

class Result extends Component {
    render() {
        return(
            <div className="results">
                <img className="bannerImageResult" src="https://resize.indiatvnews.com/en/resize/newbucket/1200_-/2020/09/10th-board-results-2020-1600322016.jpg" alt="Result" />
                <br />
                <h3>Check you VTU Results <a href="https://results.vtu.ac.in/" target="_blank" rel="noopener noreferrer">here</a></h3>
            </div>
        )
    }
}


export default Result;
